import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import MegaMenu from "./megamenu";
import NavMenubar from "./nav-menubar";
import HeaderBrandRow from "./header-brand-row";
import styles from "./styles.m.css";
import FullWidthSearch from "../../rows/header/full-width-search";
import { fetchDynamicpaywal } from "../../../api";
import { LoadingIndicatorComponent } from "../../atoms/loading-indicator";
import { checkAppSlug } from "../../utils/utils";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMegaMenuOpen: false,
      isSearchOpen: false,
      loginData: {},
      subscriptionLink: props.subscriptionLink
    };
    this.onMegaMenuToggle = this.onMegaMenuToggle.bind(this);
    this.onSearchToggle = this.onSearchToggle.bind(this);
    this.handleEscapeKeyPress = this.handleEscapeKeyPress.bind(this);
    this.handleGlobalClick = this.handleGlobalClick.bind(this);
    this.searchRef = null;
    this.searchButtonDesktopRef = null;
  }

  componentDidMount() {
    window.addEventListener("keydown", this.handleEscapeKeyPress);
    window.addEventListener("click", this.handleGlobalClick);
    global.userPromise.then(this.props.addUser);
    fetchDynamicpaywal()
      .then(access => {
        if (access.testgroup === "B" && access.p2s === 1) {
          this.setState(prevState => ({
            subscriptionLink: {
              ...prevState.subscriptionLink,
              href: "https://store.vikatan.com/?pw=2&utm_medium=header&utm_source=dynamic"
            }
          }));
        }
      })
      .catch(console.error);
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleEscapeKeyPress);
    window.removeEventListener("click", this.handleGlobalClick);
  }

  static getDerivedStateFromProps(props, state) {
    if (props.pageLoading && state.isMegaMenuOpen) {
      return { isMegaMenuOpen: false };
    }

    return null;
  }

  handleGlobalClick(event) {
    if (
      this.searchRef &&
      !this.searchRef.contains(event.target) &&
      this.searchButtonDesktopRef &&
      !this.searchButtonDesktopRef.contains(event.target) &&
      this.searchButtonMobileRef &&
      !this.searchButtonMobileRef.contains(event.target)
    ) {
      this.setState({ isSearchOpen: false });
    }
  }

  handleEscapeKeyPress(event) {
    if (event.key === "Escape" || event.keyCode === 27) {
      if (this.state.isMegaMenuOpen) {
        this.setState({ isMegaMenuOpen: false });
      }
      if (this.state.isSearchOpen) {
        this.setState({ isSearchOpen: false });
      }
    }
  }

  onMegaMenuToggle(event) {
    this.setState(
      function(prevState) {
        return {
          isMegaMenuOpen: !prevState.isMegaMenuOpen,
          isSearchOpen: false
        };
      },
      () => {
        if (this.state.isMegaMenuOpen) {
          window.location.hash = "header";
        } else {
          window.location.hash = "";
        }
      }
    );
    if (event instanceof global.Event) {
      event.stopPropagation();
    }
  }

  onSearchToggle(event) {
    this.setState({
      isSearchOpen: !this.state.isSearchOpen,
      isMegaMenuOpen: false
    });

    if (event instanceof global.Event) {
      event.stopPropagation();
    }
  }

  render() {
    const { menuGroup, socialLinks, appStoreLinks, latestIssues, user } = this.props;
    const { subscriptionLink } = this.state;
    if (checkAppSlug()) {
      return false;
    }
    return (
      <React.Fragment>
        <LoadingIndicatorComponent />
        <header className={styles["header"]}>
          {!user && (
            <div
              id="g_id_onload"
              data-client_id="962641865525-qk3eqej1shfi589ahq1enclp2i5soen0.apps.googleusercontent.com"
              data-login_uri="https://login.vikatan.com/api/smart_lock_api.php"
              data-redirecturl={global.location && global.location.href}
            />
          )}
          <HeaderBrandRow
            user={this.props.user}
            appStoreLinks={appStoreLinks}
            latestIssues={latestIssues}
            onMegaMenuToggle={this.onMegaMenuToggle}
            isMegaMenuOpen={this.state.isMegaMenuOpen}
            subscriptionLink={subscriptionLink}
            onSearchToggle={this.onSearchToggle}
            isSearchOpen={this.state.isSearchOpen}
            vikatanHosts={this.props.vikatanHosts}
            searchButtonRef={ref => {
              this.searchButtonMobileRef = ref;
            }}
          />
          <NavMenubar
            menuGroup={menuGroup}
            socialLinks={socialLinks}
            onMegaMenuToggle={this.onMegaMenuToggle}
            isMegaMenuOpen={this.state.isMegaMenuOpen}
            onSearchToggle={this.onSearchToggle}
            isSearchOpen={this.state.isSearchOpen}
            searchButtonRef={ref => {
              this.searchButtonDesktopRef = ref;
            }}
          />

          <FullWidthSearch
            searchRef={ref => {
              this.searchRef = ref;
            }}
            isOpen={this.state.isSearchOpen}
            buttonClick={this.onSearchToggle}
          />

          {this.state.isMegaMenuOpen ? (
            <React.Fragment>
              <MegaMenu
                className={styles["megamenu-overlay"]}
                menuGroup={menuGroup}
                socialLinks={socialLinks}
                appStoreLinks={appStoreLinks}
                latestIssues={latestIssues}
                subscriptionLink={subscriptionLink}
              />
              <style>{":root{--body-height: 100vh;} body{overflow:hidden;}"}</style>
            </React.Fragment>
          ) : null}
        </header>
      </React.Fragment>
    );
  }
}

Header.propTypes = {
  menuGroup: MegaMenu.propTypes.menuGroup,
  appStoreLinks: MegaMenu.propTypes.appStoreLinks,
  socialLinks: MegaMenu.propTypes.socialLinks,
  latestIssues: MegaMenu.propTypes.latestIssues,
  subscriptionLink: HeaderBrandRow.propTypes.subscriptionLink,
  pageLoading: PropTypes.bool,
  addUser: PropTypes.func,
  user: PropTypes.object,
  vikatanHosts: HeaderBrandRow.propTypes.vikatanHosts
};

function mapStateToProps(state) {
  const data = get(state, ["qt", "data", "header"]);
  const pageLoading = get(state, ["pageLoading"], false);
  const user = get(state, ["user"]);
  const vikatanHosts = get(state, ["qt", "config", "vikatanHosts"]);
  return data ? { ...data, pageLoading, user, vikatanHosts } : {};
}

function mapDispatchToProps(dispatch) {
  // move this to app.js maybe
  return {
    addUser: function(user) {
      dispatch({
        type: "ADD_USER",
        user
      });
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header);
